<template>
    <modal v-if="followersModal" @close="followersModal = false" class="importText empty-msg-mdl follow-modal">
        <div slot="modalFixed">
            Lorem ipsum dolor sit amet
        </div>
        <div slot="closeModal" class="x-msg-mdl-cls" @click="followersModal = false">
           <img alt="commaful-logo" src="../../assets/images/x.png" />
        </div>
        <div slot="header">
          <div class="searchFriendInModal">
            <input type="test" placeholder="Search followers" >
            <img alt="commaful-logo" src="../../assets/images/Search.png" />
          </div>
        </div>
        <div slot="body" class="folow-mdl-bdy">
          <div class="suggest-creator-single" v-for="(data,key) in followers" :key="key" :class="{'isFolowing-ck':data.isFolowing}">
            <div class="creator-single-wrap">
              <img :src="require(`@/assets/images/${data.img}`)" :alt="data.name" />
              <div class="suggest-creator-desc">
                <h2>{{ data.name }}</h2>
                <p>@{{ data.userName }}</p>
              </div>
            </div>
            <div class="creator-single-btn">
              <button @click="following(key)" type="button" v-if="data.isFolowing">
                <img  src="../../assets/icon/green-check.svg" alt="icon" />
              </button>
              <button @click="following(key)" type="button"  v-else>
                <img src="../../assets/icon/plus-icon.svg" alt="icon" />
              </button>
            </div>
          </div>
        </div>
        <div slot="footer" class="import-btn"></div>
    </modal>
</template>


<script>

import { EventBus } from '../../main';
export default {
  name: "followers-modal",

    data() {
        return {
            followersModal:false,
            followers:[
                {
                  id:1,
                  name: 'Neville Griffin',
                  userName: 'daracantik',
                  isFolowing: false,
                  img:'f1.png'
                },
                {
                  id:2,
                  name: 'Jon Doe',
                  userName: 'frederick',
                  isFolowing: false,
                  img:'f2.png'
                },
                {
                  id:3,
                  name: 'Shuvo sd',
                  userName: 'hilda',
                  isFolowing: false,
                  img:'f3.png'
                },
                {
                  id:4,
                  name: 'Alok Paul',
                  userName: 'donatwerski',
                  isFolowing: false,
                  img:'f4.png'
                },
                {
                  id:5,
                  name: 'Neville Griffin',
                  userName: '@nevilleg',
                  isFolowing: false,
                  img:'f1.png'
                },
                {
                  id:6,
                  name: 'Neville Griffin',
                  userName: '@nevilleg',
                  isFolowing: true,
                  img:'f1.png'
                }
              ],
        }
    }, 

    methods:{
      following(id) {
        this.followers[id].isFolowing = !this.followers[id].isFolowing;
      }
    },

    created() {
        // Badges modal
        EventBus.$on('followersmodal', data => {
            this.followersModal=data;
        });
    }

}

</script>